import React from 'react';
import { connect } from 'react-redux';

import withFeatureFlags from 'hocs/withFeatureFlags';
import { handleAccessBusinessLibrary } from 'reducers/inventoryFeatures/actions';
import styles from './BusinessLibrary.css';

class BusinessLibrary extends React.Component {
  componentDidMount() {
    const { handleAccessBusinessLibrary } = this.props;

    // redirect if feature flag off
    handleAccessBusinessLibrary();
  }

  render() {
    return <div className={`${styles.container}`}> {this.props.children} </div>;
  }
}

const mapDispatchToProps = {
  handleAccessBusinessLibrary,
};

const connected = connect(
  null,
  mapDispatchToProps
)(BusinessLibrary);

const mapFlagsToProps = flags => ({
  businessLibraryMenu: flags.businessLibraryMenu,
});

export default withFeatureFlags(mapFlagsToProps)(connected);
